/* eslint-disable no-console */
import { type Dispatch } from 'redux';
import { push } from 'connected-react-router';
import * as actions from './actions';
import AccountApi from '../apis/AccountApi';
import { trackViewedPage } from '../../utilities';

export const fetchAppSettings = () => (dispatch: Dispatch) => {
  dispatch(actions.fetchAppSettingsBegin());
  return AccountApi.getAppSettings()
    .then((response) => {
      dispatch(actions.fetchAppSettingsSuccess(response));
    })
    .catch((error) => {
      console.error(error);
      dispatch(actions.fetchAppSettingsFailure(error));
    });
};

export const navigateToAccountPage = (url: string) => (dispatch: Dispatch) => {
  dispatch(push(url));
  trackViewedPage(url);
};
